export default "__VITE_ASSET__B8_W6H_k__"